// import React, { useState, useMemo, useEffect } from "react";
// import { useApp } from "../../../context/AppContext";
// import PageHeader from "../../../components/PageHeader/PageHeader";
// import StatCard from "../../../components/StatCard/StatCard";
// import DataTable from "../../../components/DataTable/DataTable";
// import Modal from "../../../components/Modal/Modal";
// import Button from "../../../components/Form/Button";
// import Input from "../../../components/Form/Input";
// import Textarea from "../../../components/Form/Textarea";
// import { useToast } from "../../../context/ToastContext";
// import { apiService } from "../../../services/api"; // ✅ import apiService
// import "./Points.css";

// const AgentPoints = () => {
//   const {
//     currentUser,
//     // server-provided points & redemption data
//     agentPointsData = { points_value: 0, loyal_points_available: 0 },
//     agentPointsLoading = false,
//     fetchAgentPointsAndRedemptions,
//     addRedemptionRequest, // stub or real impl from context
//     settings,
//   } = useApp();

//   const { showToast } = useToast();
//   const [isRedemptionModalOpen, setIsRedemptionModalOpen] = useState(false);
//   const [redemptionForm, setRedemptionForm] = useState({
//     amount: "",
//     remarks: "",
//   });
//   const [submitting, setSubmitting] = useState(false);

//   // fetch agent points on mount (and whenever currentUser changes)
//   useEffect(() => {
//     if (typeof fetchAgentPointsAndRedemptions === "function") {
//       // ignore errors at UI level; context handles state
//       fetchAgentPointsAndRedemptions().catch(() => {});
//     }
//   }, [fetchAgentPointsAndRedemptions, currentUser]);

//   // prefer server values; fallback to local loyalty/settings if available
//   const currentPoints = useMemo(() => {
//     return Number(agentPointsData.loyal_points_available ?? 0);
//   }, [agentPointsData]);

//   const pointsValueFromServer = useMemo(() => {
//     return Number(agentPointsData.points_value ?? 0);
//   }, [agentPointsData]);

//   // If no server rate available, fallback to settings.pointsToCurrencyRate and local loyalty (kept simple)
//   const pointsToCurrencyRate =
//     settings?.pointsToCurrencyRate ?? settings?.cashback_value ?? 0;

//   const pointsValue =
//     pointsValueFromServer ||
//     Math.round(currentPoints * (pointsToCurrencyRate || 0));

//   // Keep history blank for now
//   const historyColumns = [
//     {
//       key: "date",
//       label: "Date",
//       render: (value) =>
//         value ? new Date(value).toLocaleString("en-IN") : "—",
//     },
//     {
//       key: "type",
//       label: "Type",
//     },
//     {
//       key: "pointsChange",
//       label: "Points",
//     },
//     {
//       key: "notes",
//       label: "Notes",
//     },
//   ];

//   const handleRedemptionRequest = async () => {
//     const amount = parseFloat(redemptionForm.amount);

//     if (!amount || amount <= 0) {
//       showToast("Please enter a valid amount", "error");
//       return;
//     }

//     // calculate points required using server-provided rates if available, else fallback to settings
//     const rate = pointsToCurrencyRate || 0;
//     if (rate <= 0) {
//       showToast(
//         "Redemption currently unavailable (invalid conversion rate)",
//         "error"
//       );
//       return;
//     }

//     const pointsRequired = Math.ceil(amount / rate);

//     if (pointsRequired > currentPoints) {
//       showToast("Insufficient points", "error");
//       return;
//     }

//     try {
//       setSubmitting(true);
//       // call context function. Implementation may POST to backend or be a local stub.
//       await addRedemptionRequest({
//         amount,
//         points: pointsRequired,
//         remarks: redemptionForm.remarks,
//       });

//       showToast("Redemption request submitted successfully!", "success");
//       setIsRedemptionModalOpen(false);
//       setRedemptionForm({ amount: "", remarks: "" });

//       // refetch latest points to update UI
//       if (typeof fetchAgentPointsAndRedemptions === "function") {
//         fetchAgentPointsAndRedemptions().catch(() => {});
//       }
//     } catch (err) {
//       console.error("Failed to submit redemption:", err);
//       showToast("Failed to submit redemption request", "error");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleOpenRedemptionModal = async () => {
//     try {
//       setIsRedemptionModalOpen(true);

//       // auto-hit API when modal opens
//       await apiService.redeemLoyaltyPoints();

//       // OPTIONAL: refresh latest points after hitting redeem
//       if (typeof fetchAgentPointsAndRedemptions === "function") {
//         fetchAgentPointsAndRedemptions().catch(() => {});
//       }
//     } catch (err) {
//       console.error("Failed to redeem loyalty points:", err);
//       showToast("Failed to initiate redemption.", "error");
//     }
//   };

//   return (
//     <div className="agent-points">
//       <PageHeader
//         title="Points & Redemption"
//         actions={
//           <Button
//             variant="primary"
//             onClick={handleOpenRedemptionModal}
//             disabled={currentPoints === 0 || agentPointsLoading}
//           >
//             Request Redemption
//           </Button>
//         }
//       />

//       <div className="points-overview">
//         <StatCard
//           title="Current Points Balance"
//           value={currentPoints.toLocaleString("en-IN")}
//           subtitle={`≈ ₹${pointsValue.toLocaleString("en-IN")}`}
//           icon="⭐"
//         />
//         <StatCard
//           title="Points Value"
//           value={`₹${pointsValue.toLocaleString("en-IN")}`}
//           subtitle={`1 point = ₹${settings.cashback_value}`}
//           icon="💰"
//         />
//       </div>

//       <div className="points-history-section">
//         <h2 className="section-title">Points History</h2>

//         {/* History intentionally blank for now */}
//         <DataTable
//           columns={historyColumns}
//           data={[]}
//           searchable
//           searchPlaceholder="Search history..."
//           emptyMessage="No points history available."
//           loading={agentPointsLoading}
//         />
//       </div>

//       <Modal
//         isOpen={isRedemptionModalOpen}
//         onClose={() => {
//           setIsRedemptionModalOpen(false);
//           setRedemptionForm({ amount: "", remarks: "" });
//         }}
//         title="Request Redemption"
//         size="medium"
//       >
//         <div className="redemption-form">
//           <div className="redemption-info">
//             <p>
//               <strong>Available Points:</strong>{" "}
//               {currentPoints.toLocaleString("en-IN")}
//             </p>
//             <p>
//               <strong>Points Value:</strong> ₹
//               {pointsValue.toLocaleString("en-IN")}
//             </p>
//             <p>
//               <strong>Conversion Rate:</strong> 1 point = ₹
//               {pointsToCurrencyRate}
//             </p>
//           </div>

//           {/* Amount input */}
//           <Input
//             label="Redemption Amount (₹)"
//             type="number"
//             min="1"
//             value={redemptionForm.amount}
//             onChange={(e) =>
//               setRedemptionForm((prev) => ({
//                 ...prev,
//                 amount: e.target.value,
//               }))
//             }
//           />

//           {/* Remarks textarea */}
//           <Textarea
//             label="Remarks (optional)"
//             rows={3}
//             value={redemptionForm.remarks}
//             onChange={(e) =>
//               setRedemptionForm((prev) => ({
//                 ...prev,
//                 remarks: e.target.value,
//               }))
//             }
//           />

//           {redemptionForm.amount && (
//             <div className="redemption-preview">
//               <p>
//                 <strong>Points Required:</strong>{" "}
//                 {Math.ceil(
//                   parseFloat(redemptionForm.amount || 0) /
//                     (pointsToCurrencyRate || 1)
//                 ).toLocaleString("en-IN")}
//               </p>
//             </div>
//           )}

//           <div className="modal-actions">
//             <Button
//               variant="outline"
//               onClick={() => {
//                 setIsRedemptionModalOpen(false);
//                 setRedemptionForm({ amount: "", remarks: "" });
//               }}
//             >
//               Cancel
//             </Button>
//             <Button
//               variant="primary"
//               onClick={handleRedemptionRequest}
//               disabled={submitting}
//             >
//               {submitting ? "Submitting..." : "Submit Request"}
//             </Button>
//           </div>
//         </div>
//       </Modal>
//     </div>
//   );
// };

// export default AgentPoints;


import React, { useState, useMemo, useEffect, useCallback } from "react";
import { useApp } from "../../../context/AppContext";
import PageHeader from "../../../components/PageHeader/PageHeader";
import StatCard from "../../../components/StatCard/StatCard";
import DataTable from "../../../components/DataTable/DataTable";
import Modal from "../../../components/Modal/Modal";
import Button from "../../../components/Form/Button";
import Input from "../../../components/Form/Input";
import Textarea from "../../../components/Form/Textarea";
import { useToast } from "../../../context/ToastContext";
import { apiService } from "../../../services/api"; // ✅ use existing apiService
import "./Points.css";

const AgentPoints = () => {
  const {
    currentUser,
    // server-provided points & redemption data
    agentPointsData = { points_value: 0, loyal_points_available: 0 },
    agentPointsLoading = false,
    fetchAgentPointsAndRedemptions,
    addRedemptionRequest, // stub or real impl from context
    settings,
  } = useApp();

  const { showToast } = useToast();
  const [isRedemptionModalOpen, setIsRedemptionModalOpen] = useState(false);
  const [redemptionForm, setRedemptionForm] = useState({
    amount: "",
    remarks: "",
  });
  const [submitting, setSubmitting] = useState(false);

  // Points history state (fetched from API and mapped for the table)
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  // fetch agent points on mount (and whenever currentUser changes)
  useEffect(() => {
    if (typeof fetchAgentPointsAndRedemptions === "function") {
      // ignore errors at UI level; context handles state
      fetchAgentPointsAndRedemptions().catch(() => {});
    }
  }, [fetchAgentPointsAndRedemptions, currentUser]);

  // fetch points history from API
  const fetchPointsHistory = useCallback(
    async (search = "") => {
      try {
        setHistoryLoading(true);
  
        // 🔥 Call the new API wrapper
        const payload = await apiService.getAgentPointsHistory(search);
  
        const rawData = payload?.data || [];
  
        const mapped = rawData.map((item) => ({
          date: item.createdAt,
          type: item.type,
          pointsChange: item.point_value,
          notes: item.notification,
          __raw: item,
        }));
  
        // sort newest first
        mapped.sort((a, b) => new Date(b.date) - new Date(a.date));
  
        setHistoryData(mapped);
      } catch (err) {
        console.error("Failed to fetch agent points history:", err);
        showToast("Failed to load points history", "error");
        setHistoryData([]);
      } finally {
        setHistoryLoading(false);
      }
    },
    [showToast]
  );
  

  // initial load and reload when searchTerm changes (simple behaviour)
  useEffect(() => {
    // simple fetch; if you want debounce you can add it here later
    fetchPointsHistory(searchTerm).catch(() => {});
  }, [fetchPointsHistory, searchTerm]);

  // prefer server values; fallback to local loyalty/settings if available
  const currentPoints = useMemo(() => {
    return Number(agentPointsData.loyal_points_available ?? 0);
  }, [agentPointsData]);

  const pointsValueFromServer = useMemo(() => {
    return Number(agentPointsData.points_value ?? 0);
  }, [agentPointsData]);

  // If no server rate available, fallback to settings.pointsToCurrencyRate and local loyalty (kept simple)
  const pointsToCurrencyRate =
    settings?.pointsToCurrencyRate ?? settings?.cashback_value ?? 0;

  const pointsValue =
    pointsValueFromServer ||
    Math.round(currentPoints * (pointsToCurrencyRate || 0));

  // Table columns for DataTable: use renderers to format date and preserve points color/sign if needed
  const historyColumns = [
    {
      key: "date",
      label: "Date",
      render: (value) =>
        value ? new Date(value).toLocaleString("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "numeric",
          minute: "2-digit",
        }) : "—",
    },
    {
      key: "type",
      label: "Type",
    },
    {
      key: "pointsChange",
      label: "Points",
      render: (value) => {
        if (!value) return "—";
    
        const num = Number(value);
    
        const style = {
          color: num < 0 ? "red" : "green",
          fontWeight: 600,
        };
    
        return <span style={style}>{value}</span>;
      },
    },
    
    {
      key: "notes",
      label: "Notes",
      render: (value) => (value ? String(value) : "—"),
    },
  ];

  const handleRedemptionRequest = async () => {
    const amount = parseFloat(redemptionForm.amount);

    if (!amount || amount <= 0) {
      showToast("Please enter a valid amount", "error");
      return;
    }

    // calculate points required using server-provided rates if available, else fallback to settings
    const rate = pointsToCurrencyRate || 0;
    if (rate <= 0) {
      showToast(
        "Redemption currently unavailable (invalid conversion rate)",
        "error"
      );
      return;
    }

    const pointsRequired = Math.ceil(amount / rate);

    if (pointsRequired > currentPoints) {
      showToast("Insufficient points", "error");
      return;
    }

    try {
      setSubmitting(true);
      // call context function. Implementation may POST to backend or be a local stub.
      await addRedemptionRequest({
        amount,
        points: pointsRequired,
        remarks: redemptionForm.remarks,
      });

      showToast("Redemption request submitted successfully!", "success");
      setIsRedemptionModalOpen(false);
      setRedemptionForm({ amount: "", remarks: "" });

      // refetch latest points and history to update UI
      if (typeof fetchAgentPointsAndRedemptions === "function") {
        fetchAgentPointsAndRedemptions().catch(() => {});
      }
      fetchPointsHistory(searchTerm).catch(() => {});
    } catch (err) {
      console.error("Failed to submit redemption:", err);
      showToast("Failed to submit redemption request", "error");
    } finally {
      setSubmitting(false);
    }
  };

  const handleOpenRedemptionModal = async () => {
    try {
      setIsRedemptionModalOpen(true);

      // auto-hit API when modal opens (if the apiService has a redeem endpoint)
      if (typeof apiService.redeemLoyaltyPoints === "function") {
        await apiService.redeemLoyaltyPoints();
      }

      // OPTIONAL: refresh latest points and history after hitting redeem
      if (typeof fetchAgentPointsAndRedemptions === "function") {
        fetchAgentPointsAndRedemptions().catch(() => {});
      }
      fetchPointsHistory(searchTerm).catch(() => {});
    } catch (err) {
      console.error("Failed to redeem loyalty points:", err);
      showToast("Failed to initiate redemption.", "error");
    }
  };

  return (
    <div className="agent-points">
      <PageHeader
        title="Points & Redemption"
        actions={
          <Button
            variant="primary"
            onClick={handleOpenRedemptionModal}
            disabled={currentPoints === 0 || agentPointsLoading}
          >
            Request Redemption
          </Button>
        }
      />

      <div className="points-overview">
        <StatCard
          title="Current Points Balance"
          value={currentPoints.toLocaleString("en-IN")}
          subtitle={`≈ ₹${pointsValue.toLocaleString("en-IN")}`}
          icon="⭐"
        />
        <StatCard
          title="Points Value"
          value={`₹${pointsValue.toLocaleString("en-IN")}`}
          subtitle={`1 point = ₹${pointsToCurrencyRate}`}
          icon="💰"
        />
      </div>

      <div className="points-history-section">
        <h2 className="section-title">Points History</h2>

        {/* simple search input that triggers server-side fetch */}
        <div style={{ marginBottom: 12, maxWidth: 420 }}>
          <Input
            placeholder="Search history..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <DataTable
          columns={historyColumns}
          data={historyData}
          searchable={false} // we implemented server-side search above
          searchPlaceholder="Search history..."
          emptyMessage="No points history available."
          loading={agentPointsLoading || historyLoading}
        />
      </div>

      <Modal
        isOpen={isRedemptionModalOpen}
        onClose={() => {
          setIsRedemptionModalOpen(false);
          setRedemptionForm({ amount: "", remarks: "" });
        }}
        title="Request Redemption"
        size="medium"
      >
        <div className="redemption-form">
          <div className="redemption-info">
            <p>
              <strong>Available Points:</strong>{" "}
              {currentPoints.toLocaleString("en-IN")}
            </p>
            <p>
              <strong>Points Value:</strong> ₹
              {pointsValue.toLocaleString("en-IN")}
            </p>
            <p>
              <strong>Conversion Rate:</strong> 1 point = ₹
              {pointsToCurrencyRate}
            </p>
          </div>

          {/* Amount input */}
          <Input
            label="Redemption Amount (₹)"
            type="number"
            min="1"
            value={redemptionForm.amount}
            onChange={(e) =>
              setRedemptionForm((prev) => ({
                ...prev,
                amount: e.target.value,
              }))
            }
          />

          {/* Remarks textarea */}
          <Textarea
            label="Remarks (optional)"
            rows={3}
            value={redemptionForm.remarks}
            onChange={(e) =>
              setRedemptionForm((prev) => ({
                ...prev,
                remarks: e.target.value,
              }))
            }
          />

          {redemptionForm.amount && (
            <div className="redemption-preview">
              <p>
                <strong>Points Required:</strong>{" "}
                {Math.ceil(
                  parseFloat(redemptionForm.amount || 0) /
                    (pointsToCurrencyRate || 1)
                ).toLocaleString("en-IN")}
              </p>
            </div>
          )}

          <div className="modal-actions">
            <Button
              variant="outline"
              onClick={() => {
                setIsRedemptionModalOpen(false);
                setRedemptionForm({ amount: "", remarks: "" });
              }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleRedemptionRequest}
              disabled={submitting}
            >
              {submitting ? "Submitting..." : "Submit Request"}
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AgentPoints;
